;(function(){
  // ---- 1. Tạo từng chữ cái "THIENTAN®" với animation-delay tăng dần ----
  var word = "THIENTAN";
  var wrap = document.getElementById('loaderWord');
  var baseDelay = 0.55;     // thời điểm chữ đầu tiên bắt đầu (sau khi icon + chữ T hiện xong)
  var step = 0.06;          // khoảng cách giữa các chữ

  word.split('').forEach(function(ch, i){
    var el = document.createElement('span');
    el.className = 'letter';
    el.textContent = ch;
    el.style.animationDelay = (baseDelay + i * step) + 's';
    wrap.appendChild(el);
  });

  var reg = document.createElement('sup');
  reg.className = 'reg';
  reg.textContent = '®';
  reg.style.animationDelay = (baseDelay + word.length * step) + 's';
  wrap.appendChild(reg);

  var totalAnimTime = (baseDelay + word.length * step + 0.45) * 1000; // ms

  // ---- 2. Ẩn preloader khi: (a) trang đã load xong  VÀ  (b) animation đã chạy đủ ----
  var pageLoaded = false;
  var minTimeReached = false;
  var hidden = false;

  function tryHide(){
    if(pageLoaded && minTimeReached && !hidden){
      hidden = true;
      var pre = document.getElementById('preloader');
      var content = document.getElementById('site-content');
      pre.classList.add('hide');
      content.classList.add('show');
      document.body.classList.add('showed');

      // qhg_script.js giữ GSAP/WOW tạm dừng tới khi nhận tín hiệu này. Đặt cờ trên <html>
      // để script nào đăng ký muộn (sau khi event đã bắn) vẫn biết preloader đã xong.
      document.documentElement.setAttribute('data-preloader', 'done');
      document.dispatchEvent(new CustomEvent('preloader:done'));

      pre.addEventListener('transitionend', function once(){
        pre.remove();
        pre.removeEventListener('transitionend', once);
      });
    }
  }

  window.addEventListener('load', function(){
    pageLoaded = true;
    tryHide();
  });

  setTimeout(function(){
    minTimeReached = true;
    tryHide();
  }, totalAnimTime);

  // Phòng trường hợp sự kiện 'load' đã bắn trước khi script này chạy
  if(document.readyState === 'complete'){
    pageLoaded = true;
  }
})();